// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__17AZo","list":"PatternAutocomplete_list__2Az28"};